// extracted by mini-css-extract-plugin
module.exports = {"errorPageHolder":"TimeoutErrorPage_errorPageHolder__8SPQe","showboatLogo":"TimeoutErrorPage_showboatLogo__2zi8u","showboatLogoMobile":"TimeoutErrorPage_showboatLogoMobile__3UJMU"};